require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-31-of-the-best-jewellery-website-design-examples.json") })
        }
      }, "path---blog-31-of-the-best-jewellery-website-design-examples");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-31-of-the-best-jewellery-website-design-examples!./.cache/json/blog-31-of-the-best-jewellery-website-design-examples.json
// module id = 391
// module chunks = 231608221292675